import React from 'react';
import DetailSection from '@components/v2/DetailSection';
import RelatedItems from '@components/v2/RelatedItems';
import KeyValueList from '@components/v2/KeyValueList';
import { Accordion } from '@ui/molecules/Accordion';
import { InlineText } from '@ui';
import { translate } from '@utils/i18n';
import { getGeneralInfo, getAssetsInfo } from './getGeneralInfo';
const namespace = 'features.customer_portal.deficiencies.drawer';
export default function DeficiencyDetailInfo({ deficiency }) {
    return (React.createElement("div", { className: "deficiency-detail-info" },
        deficiency.relatedItems.length > 0 && (React.createElement(DetailSection, { title: translate('sections.related', { namespace }) },
            React.createElement(RelatedItems, { items: deficiency.relatedItems.map((item) => ({
                    label: item.name,
                    labelClass: item.icon,
                    items: item.items.map((relatedItem) => ({
                        display: relatedItem.label,
                        path: relatedItem.path
                    }))
                })) }))),
        React.createElement(DetailSection, { title: translate('sections.general_information', { namespace }) },
            React.createElement("div", { className: "row-fluid" },
                React.createElement("div", { className: "row-fluid" },
                    React.createElement(KeyValueList, { items: getGeneralInfo(deficiency) })),
                React.createElement("div", { className: "row-fluid deficiency-detail__notes" },
                    React.createElement(Accordion, { title: translate('sections.notes', { namespace }) },
                        React.createElement(InlineText, { width: "full", disableEdit: true }, deficiency.note || translate('no_notes_available', { namespace })))),
                getAssetsInfo(deficiency).length > 0 && (React.createElement("div", { className: "deficiency-detail__asset-details" },
                    React.createElement(KeyValueList, { items: getAssetsInfo(deficiency) })))))));
}
